import selectComponent from 'utilities/select-component'

export default class SearchNav {

    constructor(element) {
        this.$component = selectComponent(element)
        this.$input = this.$component.elements.input
        this.$submit = this.$component.elements.submit

        this.$input.on('focus', () => {
            if (!this.$component.hasClass('-open')) {
                this.$component.addClass('-open')
            }
        })

        this.$input.on('blur', () => {
            if (!this.$component.elements.submit.is(':focus')) {
                setTimeout(() => {
                    if (!this.$component.elements.submit.is(':focus')) {
                            this.$component.removeClass('-open')
                    }
                }, 200)
            }
        })
    }
}